import React from 'react';
import { Leaf, Mail, Instagram, Facebook, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import WhatsAppIcon from './WhatsAppIcon';

const Footer = () => {
  // Coordinates: 27°59'25.7"N 73°19'46.3"E
  const latitude = 27.990472;
  const longitude = 73.329528;
  const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`;
  
  return (
    <footer className="bg-[hsl(var(--charcoal))] text-[hsl(var(--cream))] mt-24">
      <div className="container mx-auto px-6 lg:px-12 py-16">
        {/* Map Section */}
        <div className="mb-12">
          <div className="flex items-center gap-2 mb-6">
            <MapPin className="w-6 h-6 text-green-400" />
            <h3 className="font-heading text-2xl text-white">Visit Our Store</h3>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-2xl">
            <iframe
              src={mapUrl}
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Store Location"
              className="w-full"
            ></iframe>
          </div>
          <div className="mt-4 text-center">
            <p className="font-body text-base text-gray-300 leading-relaxed">
              📍 RIICO Industrial Area 9 No. Road,<br />
              Rani Bazaar, Bikaner (Raj.)
            </p>
            <a 
              href={`https://www.google.com/maps?q=${latitude},${longitude}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-3 text-green-400 hover:text-green-300 font-accent text-sm uppercase tracking-wider transition-colors"
            >
              Get Directions →
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-600 to-green-800 flex items-center justify-center">
                <Leaf className="w-6 h-6 text-white" />
              </div>
              <span className="font-heading text-xl font-bold">
                Easecarry <span className="text-green-400 italic">Green</span>
              </span>
            </div>
            <p className="font-body text-sm text-gray-400 leading-relaxed">
              Premium corn-based bags that perform like plastic but disappear like nature intended.
            </p>
          </div>

          <div>
            <h3 className="font-accent font-semibold text-sm uppercase tracking-wider mb-4">Shop</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="font-body text-sm text-gray-400 hover:text-green-400 transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <a href="#new" className="font-body text-sm text-gray-400 hover:text-green-400 transition-colors">
                  New Arrivals
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-accent font-semibold text-sm uppercase tracking-wider mb-4">About</h3>
            <ul className="space-y-2">
              <li>
                <a href="#sustainability" className="font-body text-sm text-gray-400 hover:text-green-400 transition-colors">
                  Sustainability
                </a>
              </li>
              <li>
                <a href="#materials" className="font-body text-sm text-gray-400 hover:text-green-400 transition-colors">
                  Our Materials
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-accent font-semibold text-sm uppercase tracking-wider mb-4">Connect</h3>
            <div className="flex gap-4 mb-4">
              <a href="#instagram" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-green-600 flex items-center justify-center transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://wa.me/918209901273" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-[#25D366] flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon className="w-5 h-5" />
              </a>
              <a href="#facebook" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-green-600 flex items-center justify-center transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <Mail className="w-4 h-4" />
                <span className="font-body">contact@easecarry.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <WhatsAppIcon className="w-4 h-4" />
                <a 
                  href="https://wa.me/918209901273" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-body hover:text-green-400 transition-colors"
                >
                  +91 82099 01273
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="font-body text-sm text-gray-500">
            © 2026 Easecarry Green. Biodegrades in 180 days. Built with love for the planet.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;